import { ChangeDetectionStrategy, Component, OnChanges, SecurityContext, SimpleChanges, inject, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { YouTubePlayer } from '@angular/youtube-player';
import { ExternalVideoType } from '@zvoove-market/api';

@Component({
  selector: 'zv-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [YouTubePlayer],
})
export class VideoPlayerComponent implements OnChanges {
  protected sanitizer = inject(DomSanitizer);

  static youtubeScriptAdded = false;
  static vimeoScriptAdded = false;

  readonly videoId = input.required<string>();
  readonly videoType = input.required<ExternalVideoType>();
  readonly width = input(640);
  readonly height = input(390);

  youtubeVideoType = ExternalVideoType.youtube;
  vimeoVideoType = ExternalVideoType.vimeo;
  vimeoUrl?: SafeResourceUrl;
  ngOnChanges(changes: SimpleChanges): void {
    if ('videoType' in changes && this.videoType() === ExternalVideoType.youtube && !VideoPlayerComponent.youtubeScriptAdded) {
      // This code loads the IFrame Player API code asynchronously, according to the instructions at
      // https://developers.google.com/youtube/iframe_api_reference#Getting_Started
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);

      VideoPlayerComponent.youtubeScriptAdded = true;
    }

    if ('videoType' in changes && this.videoType() === ExternalVideoType.vimeo && !VideoPlayerComponent.vimeoScriptAdded) {
      // This code loads the IFrame Player API code asynchronously, according to the instructions at
      // https://help.vimeo.com/hc/en-us/articles/12425790245777-Troubleshoot-Fullscreen-button-missing-from-the-player
      const tag = document.createElement('script');
      tag.src = 'https://player.vimeo.com/api/player.js';
      document.body.appendChild(tag);

      VideoPlayerComponent.vimeoScriptAdded = true;
    }

    if ('videoId' in changes && this.videoType() === ExternalVideoType.vimeo) {
      this.vimeoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.sanitizer.sanitize(SecurityContext.URL, 'https://player.vimeo.com/video/' + this.videoId()) || ''
      );
    }
  }
}
